module.exports = __webpack_public_path__ + "static/media/all-end-call.88b8591d.svg";